import remote from '../remote'

const state = {
  basePrice: []
}

const getters = {
  FERALCO_BASE_PRICES: state => {
    return state.basePrice
  },
  FERALCO_BASE_PRICE_CURRENT: (state, getters) => () => {
    return state.basePrice.find(price => price.active === 1)
  }
}

const mutations = {
  SET_FERALCO_BASE_PRICES: (state, payload) => {
    state.basePrice = payload
  },
  SET_FERALCO_BASE_PRICE: (state, basePrice) => {
    state.basePrice = [
      ...state.basePrice.map(item => item.id !== basePrice.id ? item : { ...item, ...basePrice })
    ]
  }
}

const actions = {
  GET_FERALCO_BASE_PRICES: async (context, payload) => {
    let { data } = await remote().get('/api/feralcoprices')
    context.commit('SET_FERALCO_BASE_PRICES', data)
  },
  ADD_FERALCO_BASE_PRICE: async (context, payload) => {
    let { data } = await remote().post('/api/feralcoprices', { feralcopricelist: payload })
    context.commit('SET_FERALCO_BASE_PRICE', data)
  }
}

export default {
  state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/modules/feralcoprice.js